export default __webpack_public_path__ + "static/media/spaakring_verend_3x_2.e580f3eb.png";